
import { defineComponent } from 'vue'
import { useReflectiveInjector, Type } from '@tanbo/vue-di-plugin'
import AccountManageHeader from '../components/AccountManageHeader.vue'
import { AccountManageLoginService } from '../components/loginApi.service'
import { ToastService } from '@/services/toast.service'
import { ConfigService } from '@/services/config.service'

const NOTICE_LIST = [
  '1.本账号的登录信息、可牛系列用户权益将全部删除，且无法恢复。',
  '2.本账号的发票、订单等记录将全部清空，无法转移、退还或恢复。',
  '3.再次使用当前绑定的手机号/微信登录，将会创建新的账号，无法找回本次注销的账号及其数据。',
]

export default defineComponent({
  name: 'AccountDeleteNotice',
  components: {
    AccountManageHeader
  },
  props: {
    closeToken: {
      type: String,
      required: true
    }
  },
  emits: ['close', 'success'],
  setup(props, { emit }) {
    const injector = useReflectiveInjector([AccountManageLoginService])
    const loginService = injector.get(AccountManageLoginService)
    const toast = injector.get(ToastService)
    const config = injector.get(ConfigService as Type<ConfigService>)

    function closeModal() {
      emit('close')
    }

    function confirmDelete() {
      // 调用注销账号接口
      loginService.requestDeleteAccount({
        close_token: props.closeToken as string
      })
        .then(() => {
          // 注销成功
          emit('success')
        })
        .catch((err) => {
          console.error('注销账号失败:', err)
          toast.showToast({ message: err.msg || '注销失败，请重试' })
        })
    }

    function openLink() {
      // 打开账号注销须知链接
      const link = config.getAccountDeleteProtocolLink
      if (link) {
        window.open(link, '_blank')
      } else {
        console.warn('未配置账号注销须知链接')
      }
    }

    return {
      NOTICE_LIST,
      closeModal,
      openLink,
      confirmDelete
    }
  }
})
